<template>
  <el-dialog title="充值余额" width="500px" :visible.sync="formVisible" :close-on-click-modal="false" @close="closeFun">
    <div>
      <div class="contDiv">
        <div style="width: 100px;padding: 10px 0;">充值金额</div>
        <div class="inputs"><el-input v-model="amtsVal" placeholder="请输入充值金额" :disabled="submiting"></el-input></div>
        <div><el-button class="chongBtn" type="warning" :disabled="submiting" @click="chongZhiFun">确定充值</el-button></div>
      </div>

      <div class="wxpaydv" v-show="submiting">
        <div class="pay-wars">支付过程中请勿刷新页面或关闭浏览器!!!</div>
        <div style="display: flex">
          <div ref="qrcodeDiv" class="wxqrcode"></div>
          <div class="payleft">
            <div class="wxpayamt">￥{{ amtsVal }}</div>
            <div class="wxpayimg">
              <img src="//static.jazpan.com/img/wxpayx.png" />
              <img src="//static.jazpan.com/img/alipayx.png" />
              <div class="infos">微信 & 支付宝 扫码支付</div>
            </div>
          </div>
        </div>
        <!-- <el-tabs v-model="activeName">
          <el-tab-pane label="微信支付" name="wxpay">
            <div style="display:flex;">
              <div ref="wxqrcode" class="wxqrcode"></div>
              <div class="payleft">
                <div class="wxpayamt">￥{{ amtsVal }}</div>
                <div class="wxpayimg"><img src="//static.jazpan.com/img/wxpay.jpg"></div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="支付宝支付" name="alipay">
            <div style="display:flex;">
              <div ref="aliqrcode" class="wxqrcode"></div>
              <div class="payleft">
                <div class="wxpayamt">￥{{ amtsVal }}</div>
                <div class="wxpayimg"><img src="//static.jazpan.com/img/alipay.jpg"></div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs> -->
      </div>
      <div class="infotxts">
        <ul>
          <li>付款后不支持退款 ! ! !</li>
        </ul>
      </div>
    </div>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click="checkFun" :loading="formLoading">我已支付完成</el-button>
    </div>
  </el-dialog>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      formVisible: false,
      formLoading: false,
      submiting: false,
      activeName: 'wxpay',
      amtsVal: '',
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'getUserInfo'
    ])
  },
  methods: {
    close () {
      if (this.formVisible == true)
        this.formVisible = false;
    }, show () {
      this.formVisible = true;
      this.submiting=false;
      this.activeName='wxpay';
      this.amtsVal='';
    }, closeFun (e) {
      // console.log('closeFun', e);
      this.$emit('close');
    }, chongZhiFun () {
      if (this.submiting)
        return;
      this.submiting = true;
      this.showQrcode();
      /* this.$confirm('确定充值吗?', '提示', {
        type: 'warning'
      }).then(() => {
        // this.submiting = true;
        
      }) */
    }, showQrcode () {
      this.$refs.qrcodeDiv.innerHTML = '';
      let url = "http:"+this.$ApiUrl + "/user/pays/gopay/" + this.getUserInfo.uid + "?amts=" + this.amtsVal;
      new QRCode(this.$refs.qrcodeDiv, {
        text: url,
        width: 150,
        height: 150,
      });
    },checkFun(){
      window.location.reload();
    }
  }
}
</script>

<style scoped lang="scss">
.contDiv {
  text-align: center;
  margin: 20px;
  display: flex;

  .inputs {
    width: 60%;
    padding: 0 8px;
  }
}


.wxpaydv {
  text-align: center;
  margin: 20px;
}

.pay-msg {
  color: #fd482c;
}

.pay-wars {
  color: #fd8f1c;
}

.payleft {
  margin-top: 20px;
  flex: 1;
}

.wxpayamt {
  margin-top: 20px;
  color: #f60;
  font-weight: bold;
  font-size: 22px;
}

.wxpayimg {
  margin-top: 30px;
  color: #aaa;
}

.wxpayimg img {
  width: 30px;
  margin-right: 10px;
}
.wxpayimg .infos {
  margin-top: 10px;
}

.infotxts {
  color: #a1a1a1;
  border-top: 1px solid #b9bbbe;
  padding: 10px;
  text-align: left;
}

.infotxts ul {
  margin: 10px;
  padding: 0;
  list-style: decimal;
}

.infotxts ul li {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// ChongZhi.vue?05980b6e